module.exports = __webpack_public_path__ + "static/media/KUAA - Watch – Nav.f03b0985.png";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/kuaa/KUAA - Watch – Nav.png
// module id = 566
// module chunks = 0